/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Carrier_Form_Cod_Summary_TotalInputs */

const vi_carrier_form_cod_summary_total = /** @type {(inputs: Carrier_Form_Cod_Summary_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tiền thu người nhận: ${i?.amount}đ`)
};

/**

* @param {Carrier_Form_Cod_Summary_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_cod_summary_total = /** @type {((inputs: Carrier_Form_Cod_Summary_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Cod_Summary_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_cod_summary_total(inputs)
});